import {  FC, useState, useEffect, useMemo } from "react"
import { useIntl } from "react-intl"
import { PageTitle } from "../../../smallnation/layout/core"
import { TablesWidget10 } from "../../../smallnation/partials/widgets"
import { ErrorMessage } from "@hookform/error-message";
import {  useLocation, useHistory } from "react-router-dom";

//import { useForm } from "react-hookform";
import { useForm } from "react-hook-form";
import services from "../../modules/services/services";
//import $, { parseJSON } from 'jquery';
import $ from 'jquery';
//import { useNavigate } from 'react-router-dom';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
//import css from "../../../smallnation/assets/custom.css";
import UsNumberValidate from "../../modules/utility/usNumberValidate";
import { confirm } from "react-confirm-box";
import { Breadcrumb } from "react-bootstrap";
import { Link } from "react-router-dom";

const CreateCompanyUser: FC = ({ hrefIn }:any) => {
  const intl = useIntl();
  const [categories, setCategory] = useState([]);
  const [locationCounty, setLocationCounty] = useState([]);
  const [stateData, setStateData] = useState([]);
  const [companyProf, setCompanyProfile] = useState([]);

  const [switchUserId, setSwitchUserId] = useState('');
  const [switchCompanyId, setSwitchCompanyId] = useState('');
  const [switchCompanyUserCount, setSwitchCompanyUserCount] = useState('');

  const [companyList, setCompanyList] = useState([]);
  const [companyinfo, setCompanyInfo] = useState([]);
  const [companyNameGet, setCompanyNameGet] = useState([]);
  let history = useHistory();
  const red = "red";

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const user_id = queryParams.get('userId');
  var companyIdGet = queryParams.get('companyId');
  var tabId = queryParams.get('tab');

  const items = [
    { href: "/companyDetails?companyId="+companyIdGet+"&tab=1", name: "Company Details" },
    { href: "/companyDetails?companyId="+companyIdGet+"&tab="+tabId, name: "Company Users" },
    { name: "Add Company Users" },
  ];

  const {
    register,
    formState: { errors },
    handleSubmit
  } = useForm({
    criteriaMode: "all", mode: "onBlur"
  });

  function validateCheck() {
    //alert("test");
    alert(switchUserId +"--->"+switchCompanyId);

  }

  const submitValue = () => {
    var validateEditorTxt = 1;
    var email_regex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    var password_regex = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
    if ($('#first_name').val() == "") {
      $("#firstNameValidMsg").show();
      $(window).scrollTop($('#firstNameValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#firstNameValidMsg").hide();
    }

    if ($('#last_name').val() == "") {
      $("#lastNameValidMsg").show();
      $(window).scrollTop($('#lastNameValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#lastNameValidMsg").hide();
    }

    var email_id:any = $('#email_id').val();
    if (email_id == "") {
      $("#emailReqMsg").show();
      $(window).scrollTop($('#emailReqMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#emailReqMsg").hide();
    }

    if (email_id != "" && email_regex.test(email_id) == false) {
      $("#emailValidMsg").show();
      $(window).scrollTop($('#emailValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#emailValidMsg").hide();
    }

    if ($('#userRole').val() == "") {
      $("#rolevalidmsg").show();
      $(window).scrollTop($('#rolevalidmsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#rolevalidmsg").hide();
    }

    var password:any = $('#password').val();
    //alert(password);
    if (password == "") {
      $("#passwordReqMsg").show();
      $(window).scrollTop($('#passwordReqMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#passwordReqMsg").hide();
    }

    if (password != "" && password_regex.test(password) == false) {
      $("#passwordValidMsg").show();
      $(window).scrollTop($('#passwordValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#passwordValidMsg").hide();
    }

    var conf_password:any = $('#conf_password').val();
    if (conf_password == "") {
      $("#confpasswrdreqMsg").show();
      $(window).scrollTop($('#confpasswrdreqMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#confpasswrdreqMsg").hide();
    }

    if (conf_password != "" && password_regex.test(conf_password) == false) {
      $("#confpasswordValidMsg").show();
      $(window).scrollTop($('#confpasswordValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#confpasswordValidMsg").hide();
    }

    if (conf_password != password) {
      $("#matchValidMsg").show();
      $(window).scrollTop($('#matchValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#matchValidMsg").hide();
    }



    if (validateEditorTxt == 0) {
      return false;
    }
    const str = $("#phone_number").val();

    const siteId = "2";
    var accessTokenTov = sessionStorage.getItem("adminAccToken");
    const requestObject =
    {

      "siteId": "2",
      "firstName": $("#first_name").val(),
      "lastName": $("#last_name").val(),
      "email": $("#email_id").val(),
      //"companyId": $("#companyId").val(),
      "companyId": companyIdGet,
      "password": $("#password").val(),
      "roleName": $("#userRole").val()
    }
    console.log(JSON.stringify(requestObject));

    var accessTokenIn = sessionStorage.getItem("adminAccToken");
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        //'Authorization': "Bearer "+accessTokenIn
        //'Authorization': accessTokenIn
      },
      body: JSON.stringify(requestObject)
    };

    services.adminAddCompanyUser(requestOptions).then((res) => {

      //history.push('/companydirectory');
      //var companyIdSelected = $("#companyId").val();

      if (res.success == "false") {
        var msg = res.message;
        $("#msg_result").html(msg);
      } else {
        if(res.message == "Login Already Exists" ){
          $("#companyUserInfoDiv").show();
          var msg = res.message;

          if(res.roleName == "company" || res.roleName == "companyadmin" || res.roleName == "companyAdmin" || res.roleName == "employerUser" || res.roleName == "companyuser" || res.roleName == "employerAdmin"){
            $("#migrateButton").show();
          }else{
            $("#migrateButton").hide();
            msg = "Login Already Exists. This user cannot be migrated.";
          }

          setSwitchUserId(res.userId);
          setSwitchCompanyId(res.companyId)
          if(res.companyName == '' || res.companyName == null){
            $("#dup_company").html('--');
          } else{
            $("#dup_company").html(res.companyName);
          }

          if(res.roleName == '' || res.roleName == null){
            $("#dup_cuser_role").html('--');
          } else{
            $("#dup_cuser_role").html(res.roleName);
          }

          if(res.statusPerson == '' || res.statusPerson == null){
            $("#dup_cuser_status").html('--');
          } else{
            $("#dup_cuser_status").html(res.statusPerson);
          }

          if(res.statusCompany == '' || res.statusCompany == null){
            $("#dup_company_status").html('--');
          } else{
            $("#dup_company_status").html(res.statusCompany);
          }

          if(res.nofUsersInCompany == '' || res.nofUsersInCompany == null){
            $("#dup_company_user_count").html('--');
          } else{
            $("#dup_company_user_count").html(res.nofUsersInCompany);
          }

          setSwitchCompanyUserCount(res.nofUsersInCompany);
          $("#msg_result").html(msg);
        }else{
          if (res.code == '200') {
            $("#addcompanyusersuccessMessage").fadeTo(2000, 500).slideUp(500, function () {
              $("#addcompanyusersuccessMessage").slideUp(500);
            });
            setTimeout(() => {
              if(tabId == null){
                history.push('/editcompany?companyId=' + companyIdGet);
              } else{
                history.push('/companyDetails?companyId=' + companyIdGet+'&tab='+tabId);
              }

            }, 1000);
          }
          else{
            $("#addcompanyuserfailMessage").fadeTo(2000, 500).slideUp(500, function () {
              $("#addcompanyuserfailMessage").slideUp(500);
            });
            setTimeout(() => {
            }, 1000);
          }
        }
      }
    });
  }

  function migrateUser(){

    if(switchUserId =="" || switchCompanyId == ""){
      return true;
    }

    const requestObject={
        "userId":switchUserId,
        "companyId":companyIdGet,
    }
    console.log(requestObject);
    var accessTokenIn=sessionStorage.getItem("adminAccToken");
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json',
                //'Authorization': "Bearer "+accessTokenIn
                //'Authorization': accessTokenIn
              },
      body: JSON.stringify(requestObject)
    };

    services.switchUserFromCompanytoAnother(requestOptions).then((res) =>
    {
      var ssv:any = switchCompanyUserCount;

      if(ssv=="1" || ssv == 1)  {
        /////////////////////
        const requestObject2={
            "companyId":switchCompanyId,
        }

        var accessTokenIn=sessionStorage.getItem("adminAccToken");
        const requestOptions2 = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json',
                    //'Authorization': "Bearer "+accessTokenIn
                    //'Authorization': accessTokenIn
                  },
          body: JSON.stringify(requestObject2)
        };

        services.inactivateCompany(requestOptions2).then((res) =>
        {
          setTimeout(() => {
            history.push('/companyDetails?companyId='+companyIdGet);
          }, 1000);
        });
        //////////////////////
      }
      setTimeout(() => {
        history.push('/companyDetails?companyId='+companyIdGet);
      }, 1000);


    });

  }

  function getAdminProfilesList() {
    var searchTxt = "";//$('#search_input').val();
    var statuschk = 'published';
    var sortBy = '';
    var sortDir = '';
    var itemsPerPage = '15000';
    var pageNumberV = '1';
    var siteIdv = '2'
    //alert("309")
    services.adminGetCompanyList(siteIdv, itemsPerPage, pageNumberV, searchTxt, statuschk, sortBy, sortDir).then((res) => {
      console.log("#######################");
      console.log(JSON.stringify(res));
      //alert("314")
      if (res.data) {
        console.log(JSON.stringify(res));

        setCompanyList(res.data.content);
        setTimeout(() => {
          $("#companyId").val(companyIdGet);
        }, 1000);

      }


    });
  }

  function getCompanyInfo(companyId) {
    services.adminGetCompanyProfile(companyId).then((res) => {
      if (res.data) {
        setCompanyInfo(res.data);
        setCompanyNameGet(res.data.name)

      }

    });
  };
  useEffect(() => {
    $("#companyUserInfoDiv").hide();
    $("#migrateButton").hide();
    getCompanyInfo(companyIdGet);
    //validateCheck();
    //$("#companyProfileValidMsg").hide();
    // $('#phone_number').usPhoneFormat();
    ($('#phone_number') as any).usPhoneFormat();
    // getAdminProfilesList();
    $('#firstNameValidMsg').hide();
    $('#lastNameValidMsg').hide();
    $("#emailReqMsg").hide();
    $("#emailValidMsg").hide();
    $('#rolevalidmsg').hide();
    $('#passwordReqMsg').hide();
    $('#passwordValidMsg').hide();
    $("#confpasswrdreqMsg").hide();
    $("#confpasswordValidMsg").hide();
    $("#matchValidMsg").hide();
    $('#addcompanyusersuccessMessage').hide();
    $('#addcompanyuserfailMessage').hide();
    $('#msg_result').hide();

  }, []);
  return (
    <>
    <Breadcrumb style={{opacity:"0.8", paddingBottom:"15px", marginTop:"-15px", borderBottom:"1px solid #999 "}}>
      {items.map((item) =>
        item.href === hrefIn ? (
          <Breadcrumb.Item active>{item.name}</Breadcrumb.Item>
        ) : (
          <Breadcrumb.Item linkProps={{ to: item.href }} linkAs={Link}>
            {item.name}
          </Breadcrumb.Item>
        )
      )}
    </Breadcrumb>
      <PageTitle breadcrumbs={[]}>Add Company user </PageTitle>
      <strong>Company Name: </strong>{companyNameGet}
      <form onSubmit={handleSubmit(submitValue)}>
        <div className="container">
          <div className="row">




            {/* <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className="required form-label">Company Name</label>

                </div>
                <select className="form-select" id="companyId" name="companyId" aria-label="Select example" >
                  <option selected value="" >Select Company</option>
                  {
                    companyList.map((data, index) => (
                      <option value={data.companyId} >{data.name}</option>
                    ))}
                </select>

              </div>
            </div> */}



            <div className="col-lg-12">
              <div className="mb-10">
              </div></div>

            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" className=" required form-label">First Name</label>

                </div>
                <input type="text" id="first_name" name="first_name" className="form-control" placeholder="" />

                <div id="firstNameValidMsg" style={{ color: red }} className="error">First Name is required.</div>
              </div>
            </div>


            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" className=" required form-label">Last Name</label>

                </div>
                <input type="text" id="last_name" name="last_name" className="form-control" placeholder="" />

                <div id="lastNameValidMsg" style={{ color: red }} className="error">Last Name is required.</div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className="required form-label">Email</label>
                  <small className="mb-3">Must be valid for notification</small>
                </div>
                <input type="text" id="email_id" name="email_id" className="form-control" placeholder="" />
                <div id="emailReqMsg" style={{ color: red }} className="error">Email Address is required.</div>

                <div id="emailValidMsg" style={{ color: red }} className="error">Invalid email address.</div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className="required form-label">Role</label>

                </div>
                <select className="form-select" id="userRole" name="userRole" aria-label="Select example" >
                  <option selected value="companyuser" >Employer User</option>
                  <option selected value="companyadmin" >Employer Admin</option>

                </select>
                <div id="rolevalidmsg" style={{ color: red }} className="error">Role is required.</div>
              </div>
            </div>


            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" className=" required form-label">Password</label>
                  <small className="mb-3">Minimum of 8 characters long, and a combination of lowercase & uppercase letters, numbers, and special characters.</small>
                </div>
                <input type="password" id="password" name="password" className="form-control" placeholder="" />

                <div id="passwordReqMsg" style={{ color: red }} className="error">Password is Required.</div>

                <div id="passwordValidMsg" style={{ color: red }} className="error">Password contain uppercase,lowercase and special character.</div>
              </div>
            </div>


            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" className=" required form-label">Confirm Password</label>
                  <small className="mb-3">Minimum of 8 characters long, and a combination of lowercase & uppercase letters, numbers, and special characters.</small>
                </div>
                <input type="password" id="conf_password" name="conf_password" className="form-control" placeholder="" />

                <div id="confpasswrdreqMsg" style={{ color: red }} className="error">Confirm Password is Required.</div>

                <div id="confpasswordValidMsg" style={{ color: red }} className="error">Password contain uppercase,lowercase and special character.</div>

                <div id="matchValidMsg" style={{ color: red }} className="error">Confirm Password should match with Password.</div>
              </div>
            </div>


            <div className="col-lg-12">
              <div className="mb-10">
                <div className="d-flex flex-column ">

                  <div className="row">




                    {errors.category && errors.category.type === "required" && <div style={{ color: red }} className="error">Please check atleast One category</div>}



                    <button type="submit" className="btn btn-primary my-10" style={{ maxWidth: "200px" }}>Create User</button>

                    <div>
                      <span id="msg_result " className="alert alert-danger" style={{display:"none"}} role="alert"></span>
                    </div>
                    <div id="addcompanyusersuccessMessage" className="alert alert-success" role="alert">Company User Created Successfully</div>
                    <div id="addcompanyuserfailMessage" className="alert alert-danger" role="alert">Please try again</div>
                  </div>
                </div>

              </div>
            </div>



            <div id="companyUserInfoDiv">
            <h3>The user you are trying to add already exists in the system. Please review below.</h3>
            {/* begin::Table */}
            <table className='table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3'>
              {/* begin::Table head */}
              <thead>
                <tr className='fw-bolder text-muted'>
                  {/* <th className='w-25px'>
                  <div className='form-check form-check-sm form-check-custom form-check-solid'>
                    <input
                      className='form-check-input'
                      type='checkbox'
                      value='1'
                      data-kt-check='true'
                      data-kt-check-target='.widget-13-check'
                    />
                  </div>
                </th> */}
                  <th className='min-w-150px'>Company Name</th>
                  <th className='min-w-120px'>Company Status</th>
                  <th className='min-w-120px'>User Role</th>
                  <th className='min-w-120px'>User Status</th>
                  <th className='min-w-120px'>Number of Users in this company</th>

                </tr>
              </thead>

              <tbody>


              <tr>
                <td>
                  <span id="dup_company"></span>
                </td>
                <td>
                  <span id="dup_company_status"></span>
                </td>
                <td>
                  <span id="dup_cuser_role"></span>
                </td>
                <td>
                  <span id="dup_cuser_status"></span>
                </td>

                <td>
                  <span id="dup_company_user_count"></span>
                </td>
              </tr>


              </tbody>

            </table>

              <span id="migrateButton">
            <button  type="button" className="btn btn-primary mt-10" style={{ maxWidth: "500px" }} onClick={migrateUser}> Migrate this user to "{companyNameGet}" </button>
            </span>

          </div>




          </div>
        </div>
      </form>
    </>
  )
}
export { CreateCompanyUser }